import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'apparel_collections-video_failed_to_play-action_unknown';
/**
 * In some circumstances, videos couldn&#39;t play. Send an event when the video couldn&#39;t play
 */
export function trackApparelCollectionsVideoFailedToPlay(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken,
            customParameterToken2,
            customParameterToken3,
        },
    });
}
